import 'vant/lib/uploader/index.less'

// 依赖
import '../preview-text/style'
